import type { PlaceholderResource } from "../../types/injectables";
import type { AdvertoryDeviceType, AdvertoryTargetId } from "./types";

const backfillPlacements = {
  desktop: "backFillDesktop1",
  mobile: "backFillMobile1",
} as const;

const numberedTargetPatterns = {
  desktop: /^(?:injectableDesktop|backfillDesktop)(1[0-6]|[1-9])$/i,
  mobile: /^(?:injectableMobile|backfillMobile)(1[0-6]|[1-9])$/i,
} as const;

const getAdvertoryTargetId = (
  resource: PlaceholderResource,
  deviceType: AdvertoryDeviceType,
): AdvertoryTargetId | null => {
  const position = resource.resource[deviceType]?.rules?.position;
  if (!position) return null;
  const normalizedPosition = position.trim().toLowerCase();

  // Content API display placeholders use the unnumbered newsfeed names. The
  // Advertory front configuration exposes the same opportunity as modul_1 or
  // panorama_1, depending on the active device.
  if (
    normalizedPosition === "newsfeed" ||
    normalizedPosition === "newsfeeddesktop"
  ) {
    return deviceType === "desktop" ? "modul_1" : "panorama_1";
  }

  if (normalizedPosition === backfillPlacements[deviceType].toLowerCase()) {
    return deviceType === "desktop"
      ? "modul_backfill_1"
      : "panorama_backfill_1";
  }

  const match = normalizedPosition.match(numberedTargetPatterns[deviceType]);
  if (!match) return null;

  const targetId = normalizedPosition.startsWith("backfill")
    ? deviceType === "desktop"
      ? "modul_backfill_1"
      : "panorama_backfill_1"
    : deviceType === "desktop"
      ? `modul_${match[1]}`
      : `panorama_${match[1]}`;

  return targetId as AdvertoryTargetId;
};

export { getAdvertoryTargetId };
